import { type TTgbNativedescGeneralContext } from '@cian/adfox-templates';

import { type FC } from 'react';

import { useAdfoxContext } from '@/packages/adfox/AdfoxContext';
import { useGetBannerEnrichmentsQuery } from '@/packages/query-state/shared/store/ad-banner/v1/get-banner-enrichments/query';

import { type TObjectType } from '@/repositories/generated/shared/ad-banner/entities/get_banner_enrichments_v1/GetBannerEnrichmentsV1Request';

import {
  TgbNativedescGeneral,
  type TgbNativedescGeneralProps,
} from './internal/components/TgbNativedescGeneral/TgbNativedescGeneral';
import { TgbNativedescGeneralNarrow } from './internal/components/TgbNativedescGeneralNarrow';

type TgbNativedescGeneralContainerProps = {
  context: TTgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: FC<TgbNativedescGeneralContainerProps> = ({ context }) => {
  const {
    annotation,
    image,
    url,
    metroDistance,
    metroColor,
    metro,
    description,
    title,
    location,
    button,
    label,
    logoImageUrl,
    builderName,
    objectId,
    objectType,
    dealType,
    useServerEnrichment,
    mortgageTermsWarning,
    mortgageWarning,
  } = context;

  const { isNarrow, serverData, sizes } = useAdfoxContext();

  /**
   * @description Только для значения useServerEnrichment === '1' делаем запрос на бекенд для обогащения данных
   */
  const isEnrichmentFromBackendEnabled = useServerEnrichment === '1';

  const objectIdInt = objectId && isEnrichmentFromBackendEnabled ? parseInt(objectId, 10) : undefined;

  const { data } = useGetBannerEnrichmentsQuery(
    { objectId: objectIdInt as number, dealType, objectType: objectType as TObjectType },
    { enabled: isEnrichmentFromBackendEnabled && Boolean(objectId), select: d => d.enrichments },
  );

  const tgbNativedescGeneralProps = ((): TgbNativedescGeneralProps => {
    const props: TgbNativedescGeneralProps = {
      logoImageUrl,
      url,
      transports: [],
      label,
      button,
      image,
      annotation,
      builderName,
      title,
      address: location,
      description,
      sizes,
      mortgageTermsWarning,
      mortgageWarning,
    };

    if (metro) {
      props.transports.push({
        iconColor: metroColor,
        iconType: serverData.additionalParams.undergroundIconType,
        id: 1,
        name: metro,
        remoteness: metroDistance,
      });
    }

    if (data) {
      Object.assign<TgbNativedescGeneralProps, Partial<TgbNativedescGeneralProps>>(props, {
        address: data.address,
        builderName: data.publisher.name,
        logoImageUrl: data.publisher.logo.url,
        transports: data.transports,
      });
    }

    return props;
  })();

  if (isNarrow) {
    return <TgbNativedescGeneralNarrow {...tgbNativedescGeneralProps} />;
  }

  return <TgbNativedescGeneral {...tgbNativedescGeneralProps} />;
};
